import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AddButton, DropdownAsButton } from "../";
import auth_controls from "../../mocks/menuPermissions.json";
import { camelCase } from "lodash";
import authService from "../api-authorization/AuthorizeService";
const InnerLayoutButtons = ({
  buttonsList = [],
  flow,
  fields,
  dirty,
  menu,
  subMenu,
}) => {
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const subMenuItem =
    auth_controls[roleName][menu + "SubMenu"]?.[camelCase(subMenu)];
  const buttons = buttonsList?.map(
    ({ label, icon, isAddButton, isEmpty, isDropdown, ...item }, index) => {
      if (item.flow && !item.flow.includes(flow)) {
        return null;
      }

      const isAllowed = () => {
        if (icon.iconName === "trash-alt") {
          return (subMenuItem || "").includes("D") ? true : false;
        } else if (icon.iconName === "pencil-alt") {
          return (subMenuItem || "").includes("U") ? true : false;
        } else if (isAddButton) {
          return (subMenuItem || "").includes("C") ? true : false;
        } else if (icon.iconName === "times") {
          return true;
        } else {
          return true;
        }
      };
      const isLastButton = buttonsList.length - 1 === index;
      const getButton = () => {
        if (isDropdown) {
          return <DropdownAsButton label={label} {...item} />;
        }
        if (isEmpty) {
          return (
            <div key={`button-${index}`} className="px-5 mx-4">
              &nbsp;
            </div>
          );
        }
        if (isAddButton) {
          return (
            <AddButton
              menu={menu}
              subMenu={subMenu}
              key={`button-${index}`}
              onAddClick={item.onClick}
            />
          );
        }
        if (icon) {
          return (
            isAllowed() && (
              <Button
                key={`button-${index}`}
                {...item}
                variant="link"
                className="inner-layout-actions"
              >
                <FontAwesomeIcon
                  icon={icon}
                  color="#212529"
                  style={{ fontSize: "1.5rem", pointerEvents: "none" }}
                />
              </Button>
            )
          );
        } else if (
          (subMenuItem || "").includes("C") &&
          ["Cancel", "Save", "Edit", "Add", "Delete"].includes(label)
        ) {
          return (
            <Button key={`button-${index}`} {...item}>
              {label}
            </Button>
          );
        } else if ((subMenuItem || "").includes("C")) {
          return (
            <Button key={`button-${index}`} {...item}>
              {label}
            </Button>
          );
        } else if (
          (subMenuItem || "").includes("R") &&
          [
            "Cancel",
            "Save",
            "Edit",
            "Add",
            "Delete",
            "Add Trustee",
            "Add Investment",
            "Create Library",
          ].includes(label)
        ) {
          return null;
        } else {
          return (
            <Button key={`button-${index}`} {...item}>
              {label}
            </Button>
          );
        }
      };
      if (item.link) {
        return [
          <Link key={`button-${index}`} to={item.link}>
            {getButton()}
          </Link>,
          !isLastButton && <>&nbsp;&nbsp;&nbsp;</>,
        ];
      } else {
        return [getButton(), !isLastButton && <>&nbsp;&nbsp;&nbsp;</>];
      }
    }
  );
  return <div>{buttons}</div>;
};

export default InnerLayoutButtons;
